export default __webpack_public_path__ + "static/media/settings.f91ceaea.svg";